import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

import { APP_CONFIG, IAppConfig } from '@app/core/config';
import { UtilsService } from '@app/core/services';
import { ServiceListForAccount } from '../models';
import { PaymentMethodGroup, RequestType } from '../types';
import { ServiceGroupType } from './service-group-type';
import { ServicePublicList } from './service-public-list';


@Injectable({
	providedIn: 'root'
})
export class TcServiceService {

	constructor(
		@Inject(APP_CONFIG) private appConfig: IAppConfig,
		private httpClient: HttpClient,
		private utilsService: UtilsService
	) { }

	getAll(): Observable<ServicePublicList[]> {
		return this.httpClient
			.get<ServicePublicList[]>(`${this.appConfig.apiEndpoint}/v2/service/all`)
			.pipe(map(this.utilsService.handleResponse));
	}

	getFilterAll(requestType: RequestType, paymentMethodGroup: PaymentMethodGroup): Observable<ServicePublicList[]> {
		const url = `${this.appConfig.apiEndpoint}/new-core/payment-methods/e-money?requestType=${requestType}`;
		return this.httpClient
			.get<ServicePublicList[]>(url)
			.pipe(map(
				res => {
					return res['data'];
				}));
	}

	getForAccount(serviceGroupType: ServiceGroupType): Observable<ServiceListForAccount[]> {
		return this.httpClient
			.get<ServiceListForAccount[]>(`${this.appConfig.apiEndpoint}/v2/service/account/${serviceGroupType}`)
			.pipe(map(this.utilsService.handleResponse));
	}

	getForPay(): Observable<ServicePublicList[]> {
		return this.httpClient
			.get<ServicePublicList[]>(`${this.appConfig.apiEndpoint}/v2/service/payWithSub`)
			.pipe(map(this.utilsService.handleResponse));
	}

	getForPayWithoutSub(): Observable<ServicePublicList[]> {
		return this.httpClient
			.get<ServicePublicList[]>(`${this.appConfig.apiEndpoint}/v2/service/pay`)
			.pipe(map(this.utilsService.handleResponse));
	}

	getForPaySubServices(serviceId: number): Observable<ServicePublicList[]> {
		return this.httpClient
			.get<ServicePublicList[]>(`${this.appConfig.apiEndpoint}/v2/service/paySub/${serviceId}`)
			.pipe(map(this.utilsService.handleResponse));
	}

	getForReceive(): Observable<ServicePublicList[]> {
		return this.httpClient
			.get<ServicePublicList[]>(`${this.appConfig.apiEndpoint}/v2/service/receiveWithSub`)
			.pipe(map(this.utilsService.handleResponse));
	}

	getForReceiveWithoutSub(): Observable<ServicePublicList[]> {
		return this.httpClient
			.get<ServicePublicList[]>(`${this.appConfig.apiEndpoint}/v2/service/receive`)
			.pipe(map(this.utilsService.handleResponse));
	}

	getForReceiveSubServices(serviceId: number): Observable<ServicePublicList[]> {
		return this.httpClient
			.get<ServicePublicList[]>(`${this.appConfig.apiEndpoint}/v2/service/receiveSub/${serviceId}`)
			.pipe(map(this.utilsService.handleResponse));
	}

	getForRelated(payServiceId: number): Observable<ServicePublicList[]> {
		return this.httpClient
			.get<ServicePublicList[]>(`${this.appConfig.apiEndpoint}/v2/service/related/${payServiceId}`)
			.pipe(map(this.utilsService.handleResponse));
	}

	getForRelatedWithSub(payServiceId: number): Observable<ServicePublicList[]> {
		return this.httpClient
			.get<ServicePublicList[]>(`${this.appConfig.apiEndpoint}/v2/service/relatedWithSub/${payServiceId}`)
			.pipe(map(this.utilsService.handleResponse));
	}

	getForRelatedSubServices(parentServiceId: number, relatedServiceId: number): Observable<ServicePublicList[]> {
		return this.httpClient
			.get<ServicePublicList[]>(`${this.appConfig.apiEndpoint}/v2/service/relatedSub/${parentServiceId}/${relatedServiceId}`)
			.pipe(map(this.utilsService.handleResponse));
	}

	// use for getting subServices in select payment methods
	getSubServices(requestType: RequestType, serviceId: number): Observable<ServicePublicList[]> {
		const url = `${this.appConfig.apiEndpoint}/new-core/services/${serviceId}/sub-services?requestType=${requestType}`;

		return this.httpClient
			.get<ServicePublicList[]>(url)
			.pipe(map(this.utilsService.handleResponse));
	}
}
